export default {
    requireField: 'Поле обязательно для заполнения',
};
